import css from "./widget.scss";
import $ from "jquery";
import { getSettings, addStyle } from "./engage.common";
var iframeTarget = process.env.REACT_APP_CDN_SERVER + "/index.html";

// After document loads
$(document).ready(function () {
  // Get settings
  getSettings(window.engage.subscriberId).then(function (settings) {
    var env = settings.env;
    setupCss(settings.theme);
    injectIframe();
    addSiteClass();
    setupButtonHandlers();
    setupAutoOpen(env.AUTO_OPEN, env.OPEN_DELAY);
  });
});
function setupCss(theme) {
  addStyle(".engage-button {background-color: ".concat(theme["HEADER_BG"], "}"));
}
function injectIframe() {
  $("body").append($(
  // eslint-disable-next-line no-multi-str
  '<div class="engage-container"> \
			<div class="engage-message-frame engage-hidden" id="engage-message-frame">\
				<iframe id="engage-iframe" class="site" allow="autoplay" frameBorder="0" src=' + iframeTarget +
  // eslint-disable-next-line no-multi-str
  '></iframe>\
			</div>\
			<div class="engage-button" id="engage-button">\
				<img class="engage-chat-icon" src="https://cdn.engage.ninja/common/chat-bubble.png" style="margin-left:1px;" />\
				<img class="engage-close-icon" src="https://cdn.engage.ninja/common/x-close-icon-white.png" style="margin-left:1px;" />\
			</div>\
		</div>'));
}
function addSiteClass() {
  // TODO: Waits are ugly :(
  setTimeout(function () {
    $("#engage-iframe").contents().find("#root").addClass("site");
  }, 200);
}
function setupButtonHandlers() {
  $("#engage-button").click(function () {
    var el = $("#engage-message-frame");
    if (el.hasClass("engage-hidden") || el.is(":hidden")) {
      el.fadeIn({
        queue: false,
        duration: "medium"
      });
      el.animate({
        bottom: "100px"
      }, "fast");
      // start conversation
      var message = JSON.stringify({
        action: "OPEN"
      });
      document.getElementById("engage-iframe").contentWindow.postMessage(message, "*");
      el.removeClass("engage-hidden");
      $(".engage-chat-icon").fadeOut();
      $(".engage-close-icon").fadeIn({
        queue: true
      });
    } else {
      el.fadeOut({
        queue: false,
        duration: "fast"
      });
      el.animate({
        bottom: "80px"
      }, "fast");
      $(".engage-close-icon").fadeOut();
      $(".engage-chat-icon").fadeIn({
        queue: true
      });
    }
  });
}
function setupAutoOpen(autoOpen, openDelayMs) {
  setTimeout(function () {
    /**
     * Auto open once only in 24 hours
     */
    var lastOpened24Hours = false;
    var previousAutoOpenTime = localStorage.getItem("engage.autoOpenTime");
    if (previousAutoOpenTime) {
      previousAutoOpenTime = new Date(previousAutoOpenTime);
      var currentTime = new Date();
      var hours = Math.abs(currentTime - previousAutoOpenTime) / 36e5;
      if (hours <= 24) {
        lastOpened24Hours = true;
      }
    }
    if (autoOpen === "true" && !lastOpened24Hours) {
      localStorage.setItem("engage.autoOpenTime", new Date().toISOString());
      $("#engage-button").click();
      var aud = new Audio("https://cdn.engage.ninja/common/chime.wav");
      aud.play();
    }
  }, openDelayMs ? openDelayMs : 3500);
}

// addEventListener support for IE8
function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener) {
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent("on" + eventName, eventHandler);
  }
}

// Listen to message from child window
bindEvent(window, "message", function (e) {
  if (!e || !e.data) {
    return;
  }
  var message = JSON.parse(e.data);
  switch (message.action) {
    case "CLOSE":
      $("#engage-button").click();
      break;
    case "REACT_APP_READY":
      $("#engage-button").css("display", "flex");
      break;
    case "IFRAME_LOADED":
      var msg = JSON.stringify({
        action: "LOAD_REACT_APP",
        user_graph_id: window.engage.user_graph_id,
        subscriberId: window.engage.subscriberId,
        apiBaseUrl: process.env.REACT_APP_CHAT_SERVER
      });
      document.getElementById("engage-iframe").contentWindow.postMessage(msg, "*");
      break;
    default:
      break;
  }
});